/* Harucake Theme JS */

(function () {
  'use strict';

  /* ─────────────────────────────────────────
     CALENDAR
     ───────────────────────────────────────── */
  const OPEN_DAYS = [2, 3, 4, 5, 6]; // Tue-Sat (0=Sun)
  const MAX_DAYS_AHEAD = 30;
  const MIN_DAYS_AHEAD = 2; // at least 2 days notice

  // -- Standard cake one-off reopen dates ------------------------------------
  // These dates bypass the normal 2-day notice rule for standard product pages.
  // Keep empty unless you need to temporarily open a specific date.
  const STANDARD_FORCE_OPEN_DATES = new Set();

  const TIMESLOTS = {
    weekday: ['2:00 PM', '4:00 PM', '6:00 PM'],
    weekend: ['12:00 PM', '2:00 PM', '4:00 PM', '6:00 PM']
  };

  // -- Date-specific pickup slot display rules -------------------------------
  // These are the slots that should be DISPLAYED for each date.
  // Full slots should still be displayed here, then marked as Full below.
  // Times outside the actual pickup window should be hidden.
  const PICKUP_SLOT_DISPLAY_BY_DATE = {};

  // -- Full pickup slot overrides --------------------------------------------
  // Key = 'YYYY-MM-DD', value = array of time strings to show as full/disabled.
  // Applies to standard product pages.
  const FULL_SLOTS_BY_DATE = {
  };

  function isSlotFullOnDate(ymd, slot) {
    return !!(FULL_SLOTS_BY_DATE[ymd] && FULL_SLOTS_BY_DATE[ymd].indexOf(slot) !== -1);
  }

  // -- Standard cake full pickup slot overrides -------------------------------
  // Optional extra override for standard products only.
  // Keep this empty unless you need a full slot that applies only to standard cakes.
  const STANDARD_FULL_SLOTS_BY_DATE = {};

  function isStandardSlotFullOnDate(ymd, slot) {
    return !!(STANDARD_FULL_SLOTS_BY_DATE[ymd] && STANDARD_FULL_SLOTS_BY_DATE[ymd].indexOf(slot) !== -1);
  }
  // -- End full pickup slot overrides ----------------------------------------

  // -- Assorted Cake rule ----------------------------------------------------
  // Block pickup times before 2:00 PM when the current product is Assorted Cake.
  const ASSORTED_CAKE_MIN_MINUTES = 840; // 14 * 60

  function timeToMinutes(slot) {
    const m = String(slot).trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!m) return 0;

    let h = parseInt(m[1], 10);
    const min = parseInt(m[2], 10);
    const mer = m[3].toUpperCase();

    if (mer === 'PM' && h !== 12) h += 12;
    if (mer === 'AM' && h === 12) h = 0;

    return h * 60 + min;
  }

  function isAssortedCakeProduct() {
    const form = document.getElementById('product-form');
    if (!form) return false;

    const handle = (form.dataset.productHandle || '').toLowerCase();
    const title  = (form.dataset.productTitle  || '').toLowerCase();

    return handle.includes('assorted') || title.includes('assorted cake');
  }

  function filterSlotsForAssorted(slots) {
    if (!isAssortedCakeProduct()) return slots;

    return slots.filter(function(slot) {
      return timeToMinutes(slot) >= ASSORTED_CAKE_MIN_MINUTES;
    });
  }
  // -- End Assorted Cake rule -------------------------------------------------

  // -- Same-Day Cake quick fix -----------------------------------------------
  // Same-day products do not use the normal pickup calendar.
  // Before submit, automatically attach pickup properties and skip normal date/time validation.
  function isSameDayProduct(form) {
    if (!form) return false;

    const handle = (form.dataset.productHandle || '').toLowerCase();
    const title = (form.dataset.productTitle || '').toLowerCase();
    const sameDayFlag = String(form.dataset.sameDay || '').toLowerCase();
    const path = window.location.pathname.toLowerCase();

    return (
      sameDayFlag === 'true' ||
      handle.indexOf('same-day') !== -1 ||
      handle.indexOf('sameday') !== -1 ||
      title.indexOf('same day') !== -1 ||
      path.indexOf('/products/same-day') !== -1 ||
      path.indexOf('/products/sameday') !== -1
    );
  }

  function getTodayYMDInLosAngeles() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());

    const year = parts.find(function(p) { return p.type === 'year'; }).value;
    const month = parts.find(function(p) { return p.type === 'month'; }).value;
    const day = parts.find(function(p) { return p.type === 'day'; }).value;

    return year + '-' + month + '-' + day;
  }

  function setLineItemProperty(form, name, value) {
    if (!form) return;

    const inputName = 'properties[' + name + ']';
    let input = form.querySelector('input[name="' + inputName + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      form.appendChild(input);
    }

    input.value = value;
  }

  function prepareSameDayPickup(form) {
    if (!form) return;

    setLineItemProperty(form, 'Pickup Date', getTodayYMDInLosAngeles());
    setLineItemProperty(form, 'Pickup Time', 'Same-day pickup starting at 1:00 PM');
    setLineItemProperty(form, 'Order Type', 'Same-Day Pickup');
  }
  // -- End Same-Day Cake quick fix -------------------------------------------

  function getToday() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function addDays(date, n) {
    const d = new Date(date);
    d.setDate(d.getDate() + n);
    return d;
  }

  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() &&
           a.getMonth() === b.getMonth() &&
           a.getDate() === b.getDate();
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }

  function formatYMD(d) {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function parseDisplayDate(value) {
    if (!value) return null;

    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) return null;

    parsed.setHours(0, 0, 0, 0);
    return parsed;
  }

  function getBlackoutDates() {
    const source = document.getElementById('pickup-blackout-dates');
    const dates = new Set();

    if (!source) return dates;

    source.textContent
      .split(/\r?\n/)
      .map(function(v) { return v.trim(); })
      .filter(Boolean)
      .forEach(function(v) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(v)) dates.add(v);
      });

    return dates;
  }

  function isSelectable(d, blackoutDates, forceOpenDates) {
    if (!blackoutDates) blackoutDates = new Set();
    if (!forceOpenDates) forceOpenDates = new Set();

    const today = getToday();
    const earliest = addDays(today, MIN_DAYS_AHEAD);
    const latest = addDays(today, MAX_DAYS_AHEAD);
    const ymd = formatYMD(d);

    const isForceOpenDate = forceOpenDates.has(ymd);

    return (
      d >= today &&
      d <= latest &&
      (isForceOpenDate || d >= earliest) &&
      (OPEN_DAYS.includes(d.getDay()) || isForceOpenDate) &&
      (isForceOpenDate || !blackoutDates.has(ymd))
    );
  }

  const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  window.HaruCalendar = {
    selectedDate: null,
    viewYear: null,
    viewMonth: null,
    blackoutDates: new Set(),
    forceOpenDates: new Set(),
    wrap: null,

    init: function(wrapSelector, options) {
      if (!options) options = {};

      this.wrap = document.querySelector(wrapSelector);
      if (!this.wrap) return;

      this.blackoutDates = options.blackoutDates || new Set();
      this.forceOpenDates = options.forceOpenDates || new Set();

      const today = getToday();
      this.viewYear = today.getFullYear();
      this.viewMonth = today.getMonth();

      const self = this;

      this.wrap.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-cal-nav]');

        if (btn) {
          const dir = parseInt(btn.dataset.calNav, 10);

          self.viewMonth += dir;

          if (self.viewMonth > 11) {
            self.viewMonth = 0;
            self.viewYear++;
          }

          if (self.viewMonth < 0) {
            self.viewMonth = 11;
            self.viewYear--;
          }

          self.render();
          return;
        }

        const day = e.target.closest('[data-cal-date]');

        if (day && !day.classList.contains('cal-day--unavailable')) {
          self.selectedDate = new Date(parseInt(day.dataset.calDate, 10));
          self.selectedDate.setHours(0, 0, 0, 0);

          self.render();
          self.onSelect(self.selectedDate);
        }
      });

      this.render();
    },

    render: function() {
      if (this.selectedDate && !isSelectable(this.selectedDate, this.blackoutDates, this.forceOpenDates)) {
        this.selectedDate = null;
        this.onClear();
      }

      const today = getToday();
      const earliest = addDays(today, MIN_DAYS_AHEAD);
      const latest = addDays(today, MAX_DAYS_AHEAD);
      const firstOfMonth = new Date(this.viewYear, this.viewMonth, 1);
      const lastOfMonth  = new Date(this.viewYear, this.viewMonth + 1, 0);

      const prevDisabled = lastOfMonth < earliest;
      const nextDisabled = firstOfMonth > latest;

      let html = '<div class="cal-header">' +
        '<button class="cal-nav" data-cal-nav="-1"' + (prevDisabled ? ' disabled' : '') + '>&#8592;</button>' +
        '<span class="cal-title">' + MONTH_NAMES[this.viewMonth] + ' ' + this.viewYear + '</span>' +
        '<button class="cal-nav" data-cal-nav="1"' + (nextDisabled ? ' disabled' : '') + '>&#8594;</button>' +
        '</div><div class="cal-grid">' +
        '<div class="cal-dow">Su</div><div class="cal-dow">Mo</div><div class="cal-dow">Tu</div>' +
        '<div class="cal-dow">We</div><div class="cal-dow">Th</div><div class="cal-dow">Fr</div>' +
        '<div class="cal-dow">Sa</div>';

      const firstDay = new Date(this.viewYear, this.viewMonth, 1).getDay();
      const daysInMonth = new Date(this.viewYear, this.viewMonth + 1, 0).getDate();
      const self = this;

      for (let i = 0; i < firstDay; i++) {
        html += '<div class="cal-day cal-day--empty"></div>';
      }

      for (let d = 1; d <= daysInMonth; d++) {
        const date = new Date(self.viewYear, self.viewMonth, d);
        date.setHours(0, 0, 0, 0);

        const selectable = isSelectable(date, self.blackoutDates, self.forceOpenDates);
        const selected = self.selectedDate && sameDay(date, self.selectedDate);

        const cls = 'cal-day' +
          (!selectable ? ' cal-day--unavailable' : '') +
          (selected ? ' cal-day--selected' : '');

        html += '<div class="' + cls + '"' +
          (selectable ? ' data-cal-date="' + date.getTime() + '"' : '') +
          '>' + d + '</div>';
      }

      html += '</div>';

      this.wrap.innerHTML = html;
    },

    onSelect: function(date) {},
    onClear: function() {}
  };

  /* ─────────────────────────────────────────
     PRODUCT PAGE
     ───────────────────────────────────────── */
  function initProductPage() {
    const form = document.getElementById('product-form');
    if (!form) return;

    const blackoutDates = getBlackoutDates();

    const sizeCards = document.querySelectorAll('.size-card');
    const sizeInput = document.getElementById('size-input');
    const priceDisplay = document.getElementById('product-price');

    const sizes = {};
    sizeCards.forEach(function(card) {
      sizes[card.dataset.size] = parseInt(card.dataset.price, 10);
    });

    let selectedSize = sizeCards[0] ? sizeCards[0].dataset.size : null;
    let writingEnabled = false;
    let qty = 1;

    function getBasePrice() {
      return sizes[selectedSize] || 0;
    }

    function calcTotal() {
      return (getBasePrice() + (writingEnabled ? 10 : 0)) * qty;
    }

    function updatePrice() {
      if (priceDisplay) priceDisplay.textContent = '$' + calcTotal();
    }

    sizeCards.forEach(function(card) {
      card.addEventListener('click', function() {
        sizeCards.forEach(function(c) {
          c.classList.remove('size-card--active');
        });

        card.classList.add('size-card--active');
        selectedSize = card.dataset.size;

        if (sizeInput) sizeInput.value = selectedSize;

        updatePrice();
      });
    });

    if (sizeCards[0]) {
      sizeCards[0].classList.add('size-card--active');

      if (sizeInput) sizeInput.value = selectedSize;
    }

    const writingToggle = document.getElementById('writing-toggle');
    const writingField  = document.getElementById('writing-field');
    const writingInput  = document.getElementById('writing-text');

    if (writingToggle) {
      writingToggle.addEventListener('change', function() {
        writingEnabled = writingToggle.checked;

        if (writingField) {
          writingField.style.display = writingEnabled ? 'block' : 'none';
        }

        updatePrice();
      });
    }

    if (writingInput) {
      writingInput.addEventListener('input', function() {
        const counter = document.getElementById('char-count');

        if (counter) counter.textContent = writingInput.value.length;
      });
    }

    const qtyDisplay = document.getElementById('qty-display');
    const qtyMinus   = document.getElementById('qty-minus');
    const qtyPlus    = document.getElementById('qty-plus');
    const qtyInput   = document.getElementById('qty-input');

    function updateQty(val) {
      qty = Math.max(1, val);

      if (qtyDisplay) qtyDisplay.textContent = qty;
      if (qtyInput) qtyInput.value = qty;

      updatePrice();
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function() {
        updateQty(qty - 1);
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function() {
        updateQty(qty + 1);
      });
    }

    const dateInput       = document.getElementById('date-input');
    const dateDisplay     = document.getElementById('selected-date-display');
    const timeInput       = document.getElementById('time-input');
    const timeslotWrap    = document.getElementById('timeslot-wrap');
    const timeslotSection = document.getElementById('timeslot-section');

    const isSameDay = isSameDayProduct(form);

    // Standard force-open applies only to non-same-day products.
    const productForceOpenDates = !isSameDay
      ? STANDARD_FORCE_OPEN_DATES
      : new Set();

    function clearTimeslotUrgencyNote() {
      if (!timeslotSection) return;

      const existingNote = timeslotSection.querySelector('.hc-timeslot-urgency');
      if (existingNote) existingNote.remove();
    }

    function clearTimeslots() {
      if (timeslotWrap) timeslotWrap.innerHTML = '';
      if (timeslotSection) timeslotSection.style.display = 'none';
      if (timeInput) timeInput.value = '';

      clearTimeslotUrgencyNote();
    }

    function isTimeFullForCurrentProduct(dateYMD, slot) {
      if (isSlotFullOnDate(dateYMD, slot)) return true;

      if (isStandardSlotFullOnDate(dateYMD, slot)) {
        return true;
      }

      return false;
    }

    function getSlotsForDate(date) {
      const dateYMD = formatYMD(date);
      const day = date.getDay();

      // Date-specific display rules come first.
      // This lets us show full slots for urgency while hiding truly unavailable times.
      if (PICKUP_SLOT_DISPLAY_BY_DATE[dateYMD]) {
        return PICKUP_SLOT_DISPLAY_BY_DATE[dateYMD].slice();
      }

      // Default schedule.
      return (day === 5 || day === 6)
        ? TIMESLOTS.weekend.slice()
        : TIMESLOTS.weekday.slice();
    }

    function renderTimeslots(date) {
      if (!timeslotWrap || !timeslotSection) return;

      const dateYMD = formatYMD(date);
      let slots = getSlotsForDate(date);

      // Assorted Cake rule: hide slots before 2:00 PM.
      slots = filterSlotsForAssorted(slots);

      if (timeInput) timeInput.value = '';

      timeslotSection.style.display = 'block';

      timeslotWrap.innerHTML = slots.map(function(slot) {
        const full = isTimeFullForCurrentProduct(dateYMD, slot);
        const cls = 'timeslot-btn' + (full ? ' timeslot-btn--full' : '');
        const disabledAttr = full ? ' disabled aria-disabled="true"' : '';

        return '<button type="button" class="' + cls + '" data-time="' + slot + '"' + disabledAttr + '>' +
          '<span class="timeslot-time">' + slot + '</span>' +
          (full ? ' <span class="timeslot-full-label">Full</span>' : '') +
          '</button>';
      }).join('');

      clearTimeslotUrgencyNote();

      const hasVisibleFullSlot = slots.some(function(slot) {
        return isTimeFullForCurrentProduct(dateYMD, slot);
      });

      if (hasVisibleFullSlot) {
        const note = document.createElement('p');
        note.className = 'hc-timeslot-urgency';
        note.textContent = 'Some pickup times are already full. Please choose another available pickup time.';

        timeslotWrap.insertAdjacentElement('afterend', note);
      }
    }

    if (timeslotWrap && !timeslotWrap.dataset.bound) {
      timeslotWrap.addEventListener('click', function(e) {
        const btn = e.target.closest('.timeslot-btn');
        if (!btn) return;

        if (btn.disabled || btn.classList.contains('timeslot-btn--full')) return;

        timeslotWrap.querySelectorAll('.timeslot-btn').forEach(function(b) {
          b.classList.remove('timeslot-btn--active');
        });

        btn.classList.add('timeslot-btn--active');

        if (timeInput) timeInput.value = btn.dataset.time;
      });

      timeslotWrap.dataset.bound = 'true';
    }

    const cal = Object.create(window.HaruCalendar);

    cal.onSelect = function(date) {
      if (dateInput) dateInput.value = formatDate(date);
      if (dateDisplay) dateDisplay.textContent = formatDate(date);

      renderTimeslots(date);
    };

    cal.onClear = function() {
      if (dateInput) dateInput.value = '';
      if (dateDisplay) dateDisplay.textContent = '';

      clearTimeslots();
    };

    // Same-day products do not need the normal calendar.
    // Only initialize the normal pickup calendar for non-same-day products.
    if (!isSameDay) {
      cal.init('#cal-wrap', {
        blackoutDates: blackoutDates,
        forceOpenDates: productForceOpenDates
      });
    }

    const thumbs  = document.querySelectorAll('.thumb-btn');
    const mainImg = document.getElementById('main-product-img');

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) {
          t.classList.remove('thumb-btn--active');
        });

        thumb.classList.add('thumb-btn--active');

        if (mainImg) mainImg.src = thumb.dataset.src;
      });
    });

    function getSelectedPickupDate() {
      if (cal.selectedDate) return cal.selectedDate;
      if (dateInput && dateInput.value) return parseDisplayDate(dateInput.value);

      return null;
    }

    form.addEventListener('submit', function(e) {
      // Same-day products skip the standard pickup calendar validation.
      // The two agreement checkboxes can still be handled by HTML required fields.
      if (isSameDayProduct(form)) {
        prepareSameDayPickup(form);
        return;
      }

      const selectedDate = getSelectedPickupDate();

      if (!selectedDate) {
        e.preventDefault();
        alert('Please select a pickup date.');
        return;
      }

      if (!isSelectable(selectedDate, blackoutDates, productForceOpenDates)) {
        e.preventDefault();
        alert('This pickup date is unavailable. Please choose another date.');
        return;
      }

      if (!timeInput || !timeInput.value) {
        e.preventDefault();
        alert('Please select a pickup time.');
        return;
      }

      const selectedYMD = formatYMD(selectedDate);

      if (isTimeFullForCurrentProduct(selectedYMD, timeInput.value)) {
        e.preventDefault();
        alert('This pickup time is now full. Please select a different time.');
        return;
      }

      if (isAssortedCakeProduct() && timeToMinutes(timeInput.value) < ASSORTED_CAKE_MIN_MINUTES) {
        e.preventDefault();
        alert('Assorted Cake orders require a pickup time of 2:00 PM or later. Please select a valid time.');
        return;
      }

      if (!selectedSize) {
        e.preventDefault();
        alert('Please select a cake size.');
        return;
      }
    });

    updatePrice();
  }

  /* ─────────────────────────────────────────
     HEADER / MOBILE NAV
     ───────────────────────────────────────── */
  function initHeader() {
    const toggle = document.querySelector('.mobile-nav-toggle');
    const nav    = document.querySelector('.header-nav');

    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      const open = nav.classList.toggle('header-nav--open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  /* ─────────────────────────────────────────
     CART PAGE - quantity controls
     ───────────────────────────────────────── */
  function initCartPage() {
    document.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const row = btn.closest('[data-cart-item]');
        if (!row) return;

        const input = row.querySelector('.cart-qty-input');
        if (!input) return;

        const delta = btn.classList.contains('cart-qty-plus') ? 1 : -1;
        const val = Math.max(0, parseInt(input.value || 1, 10) + delta);

        input.value = val;

        if (input.closest('form')) {
          input.closest('form').submit();
        }
      });
    });
  }

  /* ─────────────────────────────────────────
     ANNOUNCEMENT BAR auto-dismiss
     ───────────────────────────────────────── */
  function initAnnouncement() {
    const bar   = document.querySelector('.announcement-bar');
    const close = document.querySelector('.announcement-close');

    if (!bar || !close) return;

    close.addEventListener('click', function() {
      bar.style.display = 'none';
    });
  }

  /* ─────────────────────────────────────────
     INIT
     ───────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    initHeader();
    initProductPage();
    initCartPage();
    initAnnouncement();
  });

})();